import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import Input from '@/components/Input.vue'

declare const UIkit

interface Props {
    qrUrl: string
    mfaSecret: string
    cancelText?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MFASetup',
  props: {
    qrUrl: { default: '' },
    mfaSecret: { default: '' },
    cancelText: { default: 'Cancel' }
  },
  emits: ['mfaUpdate', 'mfaCancel'],
  setup(__props: any, { emit }) {

const props = __props as { qrUrl: string, mfaSecret: string, cancelText: string };



const mfaCode = ref('')



async function verifyMfaCode() {
    emit('mfaUpdate', mfaCode.value)
}

return { __sfc: true,props, mfaCode, emit, verifyMfaCode, Input }
}

})